export default "__VITE_ASSET__BZi9e1Wg__"